import { getImagePath } from '@/shared/lib/utils/asset.ts'

export interface NotificationMetadata {
  text: string
  color: string
  imageUrl: string
}

export const NOTIFICATION: NotificationMetadata | undefined = {
  text: 'stSOMI is live!',
  color: '#4314FF',
  imageUrl: getImagePath('purple.png', 'notification'),
}
